import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const DemandCertificate = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    applicantNameMarathi: '',
    applicantNameEnglish: '',
    mobileNumber: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };

  const handleReset = () => {
    setFormData({
      applicantNameMarathi: '',
      applicantNameEnglish: '',
      mobileNumber: '',
    });
  };

  const formSectionStyle = {
    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #dee2e6',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    padding: '10px 15px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    width: '100%',
  };

  const labelStyle = {
    color: '#2c3e50',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    display: 'block',
  };

  const sectionTitleStyle = {
    color: '#2c3e50',
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #3498db',
    textAlign: 'center',
  };

  const requiredStar = {
    color: '#e74c3c',
    marginLeft: '3px',
  };

  const helpTextStyle = {
    color: '#7f8c8d',
    fontSize: '12px',
    fontStyle: 'italic',
    marginTop: '4px',
    display: 'block',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Form Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 mb-4">
            <span className="text-3xl text-white">📜</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            {language === 'marathi' ? 'मागणी प्रमाणपत्र फॉर्म' : 'Demand Certificate Form'}
          </h1>
          <p className="text-gray-600">
            {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत - नमुना ७ मागणी प्रमाणपत्र' : 'Inam Dhamani Gram Panchayat - Form 7 Demand Certificate'}
          </p>
          <div className="mt-4 w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Form Section */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदार माहिती' : 'Applicant Information'}</h2>
            
            <div className="space-y-6">
              {/* Field 1: Applicant Name in Marathi */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदाराचे नाव (मराठीमध्ये)' : 'Applicant\'s Name (in Marathi)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantNameMarathi"
                  value={formData.applicantNameMarathi}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'नमुना 7 मध्ये नोंद मालकाचे नाव मराठीमध्ये प्रविष्ट करा' : 'Enter the registered owner\'s name in Marathi as per Form 7'}
                  className="focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'नमुना ७ मध्ये नोंद मालकाचे नाव मराठीमध्ये प्रविष्ट करा' : 'Enter the registered owner\'s name in Marathi as per Form 7'}
                </span>
              </div>

              {/* Field 2: Applicant Name in English */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदाराचे नाव (इंग्रजीमध्ये)' : 'Applicant\'s Name (in English)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantNameEnglish"
                  value={formData.applicantNameEnglish}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'नमुना 7 मध्ये नोंद मालकाचे नाव इंग्रजीमध्ये प्रविष्ट करा' : 'Enter the registered owner\'s name in English as per Form 7'}
                  className="focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'नमुना ७ मध्ये नोंद मालकाचे नाव इंग्रजीमध्ये प्रविष्ट करा' : 'Enter the registered owner\'s name in English as per Form 7'}
                </span>
              </div>

              {/* Field 3: Mobile Number */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मोबाईल क्रमांक' : 'Mobile Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'अर्जदाराचा संपर्कासाठी मोबाईल क्रमांक प्रविष्ट करा' : 'Enter applicant\'s contact mobile number'}
                  pattern="[0-9]{10}"
                  maxLength="10"
                  className="focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? '10 अंकी मोबाईल क्रमांक प्रविष्ट करा' : 'Enter 10-digit mobile number'}
                </span>
              </div>
            </div>
          </div>

          {/* Form Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">
            <button
              type="submit"
              style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
              }}
            >
              {language === 'marathi' ? '📄 अर्ज सादर करा' : '📄 Submit Application'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
              }}
            >
              {language === 'marathi' ? '🔄 पुनर्स्थापित करा' : '🔄 Reset'}
            </button>
          </div>

          {/* Form Footer */}
          <div className="mt-8 text-center text-sm text-gray-600">
            <p className="mb-2">
              <span style={{color: '#e74c3c', fontWeight: 'bold'}}>*</span> {language === 'marathi' ? 'हे चिन्ह असलेले फील्ड अनिवार्य आहेत' : 'Fields marked with this symbol are mandatory'}
            </p>
            <p>
              {language === 'marathi' 
                ? 'अर्ज सादर केल्यानंतर, तुम्हाला एक अर्ज संदर्भ क्रमांक प्राप्त होईल. कृपया तो संदर्भ क्रमांक नोंदवून ठेवा.'
                : 'After submitting the application, you will receive an application reference number. Please note down that reference number.'}
            </p>
          </div>
        </form>

        {/* Information Box */}
        <div className="mt-10 p-6 bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-lg">
          <h3 className="text-lg font-semibold text-emerald-800 mb-3">{language === 'marathi' ? '📋 नमुना ७ प्रमाणपत्राची माहिती:' : '📋 Form 7 Certificate Information:'}</h3>
          <ul className="list-disc pl-5 space-y-2 text-emerald-700">
            <li className="font-medium">{language === 'marathi' ? 'हा अर्ज जमिनीच्या हक्क दाव्यासाठी वापरला जातो' : 'This application is used for land right claims'}</li>
            <li className="font-medium">{language === 'marathi' ? 'नमुना ७ प्रमाणपत्रामध्ये जमिनीच्या मालकाचे नाव नोंदवले जाते' : 'The land owner\'s name is registered in the Form 7 certificate'}</li>
            <li className="font-medium">{language === 'marathi' ? 'जमिनीच्या रेव्हेन्यू रेकॉर्डसाठी हा दाखला आवश्यक असतो' : 'This certificate is required for land revenue records'}</li>
            <li className="font-medium">{language === 'marathi' ? 'प्रमाणपत्रासाठी आवश्यक असलेली मूळ कागदपत्रे ग्रामसेवक कार्यालयात सादर करावी लागतील' : 'Original documents required for the certificate must be submitted to the Gram Sevak office'}</li>
            <li className="font-medium">{language === 'marathi' ? 'अर्ज सादर केल्यानंतर 5-7 कामकाजाच्या दिवसात प्रमाणपत्र तयार होईल' : 'The certificate will be ready in 5-7 working days after submitting the application'}</li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="mt-6 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold text-gray-700">{language === 'marathi' ? '📞 संपर्क क्रमांक:' : '📞 Contact Number:'}</p>
              <p className="text-gray-600">०२४१-XXXXXXX</p>
            </div>
            <div className="hidden sm:block h-8 w-px bg-gray-300"></div>
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold text-gray-700">✉️ ईमेल:</p>
              <p className="text-gray-600">demandcert@inamdhamani-grampanchayat.in</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandCertificate;